// src/components/financial/FinancialSummaryCards.js
import React from 'react';

function FinancialSummaryCards({ data }) {
  const cards = [
    {
      title: 'Current Balance',
      value: `₹${data.currentBalance.toFixed(2)}`,
      icon: '💼',
      color: data.currentBalance >= 0 ? '#28a745' : '#dc3545',
      trend: data.currentBalance >= 0 ? '↑' : '↓'
    },
    {
      title: 'Total Collected',
      value: `₹${data.totalCollected.toFixed(2)}`,
      icon: '💰',
      color: '#17a2b8',
      subtitle: 'This month'
    },
    {
      title: 'Total Expenses',
      value: `₹${data.totalExpenses.toFixed(2)}`,
      icon: '💸',
      color: '#ffc107',
      subtitle: 'This month'
    },
    {
      title: 'Pending Dues',
      value: `₹${data.pendingDues.toFixed(2)}`,
      icon: '⏳',
      color: '#dc3545',
      subtitle: 'To be collected'
    },
    {
      title: 'Reserve Fund',
      value: `₹${data.reserveFund.toFixed(2)}`,
      icon: '🏦',
      color: '#667eea',
      subtitle: 'Total savings'
    }
  ];

  return (
    <div style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
      gap: '15px',
      marginBottom: '20px'
    }}>
      {cards.map((card, index) => (
        <div
          key={index}
          style={{
            background: 'white',
            padding: '20px',
            borderRadius: '10px',
            boxShadow: '0 2px 5px rgba(0,0,0,0.1)',
            borderTop: `4px solid ${card.color}`
          }}
        >
          <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            marginBottom: '10px'
          }}>
            <div>
              <div style={{
                fontSize: '12px',
                color: '#666',
                marginBottom: '5px',
                textTransform: 'uppercase',
                letterSpacing: '0.5px'
              }}>
                {card.title}
              </div>
              <div style={{
                fontSize: '24px',
                fontWeight: 'bold',
                color: card.color
              }}>
                {card.value}
              </div>
              {card.subtitle && (
                <div style={{
                  fontSize: '11px',
                  color: '#999',
                  marginTop: '5px'
                }}>
                  {card.subtitle}
                </div>
              )}
            </div>
            <div style={{
              fontSize: '30px',
              opacity: 0.3
            }}>
              {card.icon}
            </div>
          </div>
          {card.trend && (
            <div style={{
              fontSize: '20px',
              color: card.color,
              textAlign: 'right'
            }}>
              {card.trend}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}

export default FinancialSummaryCards;